import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_template_message_hdr_RowInterface {
guid: fromDatatype.GuidDataFieldInterface;
namespace: fromDatatype.VarcharDatatypeInterface;
module_guid: fromDatatype.GuidDataFieldInterface;
applet_guid: fromDatatype.GuidDataFieldInterface;
name: fromDatatype.VarcharDatatypeInterface;
template_type: fromDatatype.VarcharDatatypeInterface;
channel_type: fromDatatype.VarcharDatatypeInterface;
msg_type: fromDatatype.VarcharDatatypeInterface;
body: fromDatatype.TextDatatypeInterface;
msg_status: fromDatatype.VarcharDatatypeInterface;
description: fromDatatype.TextDatatypeInterface;
start_date: fromDatatype.TimestampTzDatatypeInterface;
expiry_date: fromDatatype.TimestampTzDatatypeInterface;
property_json: fromDatatype.JsonDatatypeInterface;
acl_config: fromDatatype.JsonDatatypeInterface;
acl_policy: fromDatatype.JsonDatatypeInterface;
created_date: fromDatatype.TimestampTzDatatypeInterface;
updated_date: fromDatatype.TimestampTzDatatypeInterface;
created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
status: fromDatatype.VarcharDatatypeInterface;
revision: fromDatatype.GuidDataFieldInterface;
vrsn: fromDatatype.VarcharDatatypeInterface;
template_code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_applet_template_message_hdr_RowClass implements bl_applet_template_message_hdr_RowInterface {    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    template_type: fromDatatype.VarcharDatatypeInterface;
    channel_type: fromDatatype.VarcharDatatypeInterface;
    msg_type: fromDatatype.VarcharDatatypeInterface;
    body: fromDatatype.TextDatatypeInterface;
    msg_status: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    expiry_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    template_code: fromDatatype.VarcharDatatypeInterface;
    }